import * as R from 'ramda'
import {
  QueryFromString,
  QueryFromStringOptions,
  QueryToString,
  QueryToStringOptions
} from 'helpers/url.types'

export const queryToString: QueryToString = (
  query,
  { encodingURIComponent = true, encodingURI = true, skipEmptyParams = false }: QueryToStringOptions = {}
) => R.pipe(
  R.when(R.always(skipEmptyParams), R.pickBy(R.complement(R.isNil))),
  R.toPairs,
  R.map(R.pipe(
    R.when(R.always(encodingURIComponent), R.map(encodeURIComponent)),
    R.join('=')
  )),
  R.join('&'),
  R.concat('?'),
  R.when(R.always(encodingURI), encodeURI)
)(query)

export const queryFromString: QueryFromString = (
  string,
  { decodingURI = false, decodingURIComponent = true }: QueryFromStringOptions = {}) => R.ifElse(
  R.isEmpty,
  R.always({}),
  R.pipe(
    R.when(R.always(decodingURI), decodeURI),
    R.tail,
    R.split('&'),
    R.map(R.pipe(
      R.split('='),
      R.when(
        R.always(decodingURIComponent),
        R.map(R.compose(decodeURIComponent, R.replace(/\+/g, '%20')))
      )
    )),
    R.fromPairs
  )
)(string)
